<script setup>
import {PERMISSIONS} from "@/constants";
import useUser from "@/store/user";
import {asideStatus} from '@/store/asideStatus'
import {ref} from "vue";

const {hasAccess} = useUser()
const isHideStatus = asideStatus()
const isHideVal = ref(false)

const onShowAside = () => {
  isHideVal.value = !isHideVal.value
  isHideStatus.changeStateAside(isHideVal.value)
}
</script>
<template>
  <aside class="aside" :class="{hide: isHideStatus.isHide===true}">
    <button @click="onShowAside" class="aside__open" :class="{is__close: isHideStatus.isHide===true}">
      <img src="@/assets/icons/arrow.svg" alt="">
    </button>
    <div class="aside__inner">
      <div class="aside_logo">
        <div><img src="../assets/images/logo2.svg" alt=""></div>
        <span>DB-CONTROL</span>
      </div>
      <router-link v-if="hasAccess(PERMISSIONS['profile'])" :exact="true" class="aside_link"
                   :to="{ name: 'main-profile' }">
        <span>
           <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12.0933 14.4132C11.5066 14.5866 10.8133 14.6666 9.99995 14.6666H5.99995C5.18662 14.6666 4.49328 14.5866 3.90662 14.4132C4.05328 12.6799 5.83328 11.3132 7.99995 11.3132C10.1666 11.3132 11.9466 12.6799 12.0933 14.4132Z"
                stroke-linecap="round" stroke-linejoin="round"/>
            <path
                d="M10 1.33325H6.00004C2.66671 1.33325 1.33337 2.66659 1.33337 5.99992V9.99992C1.33337 12.5199 2.09337 13.8999 3.90671 14.4132C4.05337 12.6799 5.83337 11.3132 8.00004 11.3132C10.1667 11.3132 11.9467 12.6799 12.0934 14.4132C13.9067 13.8999 14.6667 12.5199 14.6667 9.99992V5.99992C14.6667 2.66659 13.3334 1.33325 10 1.33325ZM8.00004 9.44657C6.68004 9.44657 5.61337 8.37326 5.61337 7.05326C5.61337 5.73326 6.68004 4.66659 8.00004 4.66659C9.32004 4.66659 10.3867 5.73326 10.3867 7.05326C10.3867 8.37326 9.32004 9.44657 8.00004 9.44657Z"
                stroke-linecap="round" stroke-linejoin="round"/>
            <path
                d="M10.3866 7.05343C10.3866 8.37343 9.31995 9.44674 7.99995 9.44674C6.67995 9.44674 5.61328 8.37343 5.61328 7.05343C5.61328 5.73343 6.67995 4.66675 7.99995 4.66675C9.31995 4.66675 10.3866 5.73343 10.3866 7.05343Z"
                stroke-linecap="round" stroke-linejoin="round"/>
           </svg>
        </span>
        <p>Main</p>
      </router-link>
      <router-link v-if="hasAccess(PERMISSIONS['user'])" class="aside_link" :to="{ name: 'main-user' }">
        <span>
           <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12.0933 14.4132C11.5066 14.5866 10.8133 14.6666 9.99995 14.6666H5.99995C5.18662 14.6666 4.49328 14.5866 3.90662 14.4132C4.05328 12.6799 5.83328 11.3132 7.99995 11.3132C10.1666 11.3132 11.9466 12.6799 12.0933 14.4132Z"
                stroke-linecap="round" stroke-linejoin="round"/>
            <path
                d="M10 1.33325H6.00004C2.66671 1.33325 1.33337 2.66659 1.33337 5.99992V9.99992C1.33337 12.5199 2.09337 13.8999 3.90671 14.4132C4.05337 12.6799 5.83337 11.3132 8.00004 11.3132C10.1667 11.3132 11.9467 12.6799 12.0934 14.4132C13.9067 13.8999 14.6667 12.5199 14.6667 9.99992V5.99992C14.6667 2.66659 13.3334 1.33325 10 1.33325ZM8.00004 9.44657C6.68004 9.44657 5.61337 8.37326 5.61337 7.05326C5.61337 5.73326 6.68004 4.66659 8.00004 4.66659C9.32004 4.66659 10.3867 5.73326 10.3867 7.05326C10.3867 8.37326 9.32004 9.44657 8.00004 9.44657Z"
                stroke-linecap="round" stroke-linejoin="round"/>
            <path
                d="M10.3866 7.05343C10.3866 8.37343 9.31995 9.44674 7.99995 9.44674C6.67995 9.44674 5.61328 8.37343 5.61328 7.05343C5.61328 5.73343 6.67995 4.66675 7.99995 4.66675C9.31995 4.66675 10.3866 5.73343 10.3866 7.05343Z"
                stroke-linecap="round" stroke-linejoin="round"/>
           </svg>
        </span>
        <p>User</p>
      </router-link>
      <router-link v-if="hasAccess(PERMISSIONS['agent'])" class="aside_link" :to="{ name: 'main-agent' }">
        <span>
           <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M6.00004 14.6666H10C13.3334 14.6666 14.6667 13.3333 14.6667 9.99992V5.99992C14.6667 2.66659 13.3334 1.33325 10 1.33325H6.00004C2.66671 1.33325 1.33337 2.66659 1.33337 5.99992V9.99992C1.33337 13.3333 2.66671 14.6666 6.00004 14.6666Z"
                  stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M4.46667 6.17334L8 8.22001L11.5067 6.18667" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M8 11.8467V8.21338" stroke-linecap="round" stroke-linejoin="round"/>
              <path
                  d="M7.17338 4.1934L5.04004 5.38007C4.56004 5.64673 4.16003 6.32007 4.16003 6.8734V9.1334C4.16003 9.68673 4.55337 10.3601 5.04004 10.6267L7.17338 11.8134C7.62671 12.0667 8.37337 12.0667 8.83337 11.8134L10.9667 10.6267C11.4467 10.3601 11.8467 9.68673 11.8467 9.1334V6.86674C11.8467 6.3134 11.4534 5.64007 10.9667 5.3734L8.83337 4.18673C8.37337 3.9334 7.62671 3.9334 7.17338 4.1934Z"
                  stroke-linecap="round" stroke-linejoin="round"/>
           </svg>
        </span>
        <p>Agent</p>
      </router-link>
      <router-link v-if="hasAccess(PERMISSIONS['role'])" class="aside_link" :to="{ name: 'main-role' }">
        <span>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12 4.77325C11.96 4.76659 11.9133 4.76659 11.8733 4.77325C10.9533 4.73992 10.22 3.98659 10.22 3.05325C10.22 2.09992 10.9866 1.33325 11.94 1.33325C12.8933 1.33325 13.66 2.10659 13.66 3.05325C13.6533 3.98659 12.92 4.73992 12 4.77325Z"
                stroke-linecap="round" stroke-linejoin="round"/>
            <path
                d="M11.3133 9.62669C12.2267 9.78003 13.2333 9.62003 13.94 9.14669C14.88 8.52003 14.88 7.49336 13.94 6.86669C13.2267 6.39336 12.2067 6.23336 11.2933 6.39336"
                stroke-linecap="round" stroke-linejoin="round"/>
            <path
                d="M3.97995 4.77325C4.01995 4.76659 4.06661 4.76659 4.10661 4.77325C5.02661 4.73992 5.75995 3.98659 5.75995 3.05325C5.75995 2.09992 4.99328 1.33325 4.03995 1.33325C3.08661 1.33325 2.31995 2.10659 2.31995 3.05325C2.32661 3.98659 3.05995 4.73992 3.97995 4.77325Z"
                stroke-linecap="round" stroke-linejoin="round"/>
            <path
                d="M4.66663 9.62669C3.75329 9.78003 2.74663 9.62003 2.03996 9.14669C1.09996 8.52003 1.09996 7.49336 2.03996 6.86669C2.75329 6.39336 3.77329 6.23336 4.68663 6.39336"
                stroke-linecap="round" stroke-linejoin="round"/>
            <path
                d="M7.99997 9.75324C7.95997 9.74657 7.9133 9.74657 7.8733 9.75324C6.9533 9.7199 6.21997 8.96657 6.21997 8.03323C6.21997 7.0799 6.98664 6.31323 7.93997 6.31323C8.8933 6.31323 9.65997 7.08657 9.65997 8.03323C9.6533 8.96657 8.91997 9.72657 7.99997 9.75324Z"
                stroke-linecap="round" stroke-linejoin="round"/>
            <path
                d="M6.05998 11.8532C5.11998 12.4799 5.11998 13.5066 6.05998 14.1332C7.12665 14.8466 8.87331 14.8466 9.93998 14.1332C10.88 13.5066 10.88 12.4799 9.93998 11.8532C8.87998 11.1466 7.12665 11.1466 6.05998 11.8532Z"
                stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </span>
        <p>Role</p>
      </router-link>
      <router-link v-if="hasAccess(PERMISSIONS['database'])" class="aside_link" :to="{ name: 'main-database' }">
        <span>
         <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
              d="M12.8799 6.66676H3.12652C2.13985 6.66676 1.33984 5.8601 1.33984 4.8801V3.12676C1.33984 2.14009 2.14652 1.34009 3.12652 1.34009H12.8799C13.8665 1.34009 14.6665 2.14676 14.6665 3.12676V4.8801C14.6665 5.8601 13.8599 6.66676 12.8799 6.66676Z"
              stroke-linecap="round" stroke-linejoin="round"/>
          <path
              d="M12.8799 14.6668H3.12652C2.13985 14.6668 1.33984 13.8601 1.33984 12.8801V11.1268C1.33984 10.1401 2.14652 9.34009 3.12652 9.34009H12.8799C13.8665 9.34009 14.6665 10.1468 14.6665 11.1268V12.8801C14.6665 13.8601 13.8599 14.6668 12.8799 14.6668Z"
              stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M4 3.33325V4.66659" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M6.6665 3.33325V4.66659" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M4 11.3333V12.6666" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M6.6665 11.3333V12.6666" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M9.3335 4H12.0002" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M9.3335 12H12.0002" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>

        </span>
        <p>Database board</p>
      </router-link>
      <router-link class="aside_link" :to="{ name: 'main-project' }"
                   :class="{ 'router-link-active': ['main-project-services', 'main-service-templates'].includes($route.name) }">
        <span>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.6665 1.33325H3.33317C2.59679 1.33325 1.99984 1.93021 1.99984 2.66659V5.33325C1.99984 6.06963 2.59679 6.66659 3.33317 6.66659H12.6665C13.4029 6.66659 13.9998 6.06963 13.9998 5.33325V2.66659C13.9998 1.93021 13.4029 1.33325 12.6665 1.33325Z"
                  stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12.6665 9.33325H3.33317C2.59679 9.33325 1.99984 9.93021 1.99984 10.6666V13.3333C1.99984 14.0696 2.59679 14.6666 3.33317 14.6666H12.6665C13.4029 14.6666 13.9998 14.0696 13.9998 13.3333V10.6666C13.9998 9.93021 13.4029 9.33325 12.6665 9.33325Z"
                  stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M4.6665 4H4.67317" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M4.6665 12H4.67317" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M8 6.66675V9.33341" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </span>
        <p>Projects</p>
      </router-link>
    </div>
  </aside>
</template>
